import React, { useEffect } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable'; // Import the autoTable plugin
import moment from 'moment';
import autoTable from 'jspdf-autotable';
import { addPageNumber } from '../common/addPageNumber';

interface ExportDistrictLabelReportProps {
    data: any;
    setPdfBlob: (blob: Blob) => void;
}

const ExportDistrictLabelReport: React.FC<ExportDistrictLabelReportProps> = ({ data, setPdfBlob }) => {
    const todayDate = moment().format('DD-MM-YYYY');

    const generatePDF = () => {
        const doc = new jsPDF({
            orientation: 'landscape',
            unit: 'mm',
            format: 'a4'
        });

        // Title
        doc.setFontSize(16);
        doc.text('District Labels Report', 14, 15); // Start at (40,40) to leave margin space

        // Define columns for the report
        const columns = [
            { header: 'Principal', dataKey: 'Principal' },
            { header: 'Site Name', dataKey: 'SiteName' },
            { header: 'Address 1', dataKey: 'ADDR1' },
            { header: 'Address 2', dataKey: 'ADDR2' },
            { header: 'Address 3', dataKey: 'ADDR3' },
        ];

        // Format the data for autoTable
        const tableData = data
            .map((item: any) => ({
                Principal: item.Principal,
                SiteName: item.SiteName,
                ADDR1: item.ADDR1,
                ADDR2: item.ADDR2,
                ADDR3: item.ADDR3,
            }));

        // Generate the table using autoTable
        autoTable(doc, {
            head: [columns.map(col => col.header)],
            body: tableData.map((row: { [s: string]: unknown; } | ArrayLike<unknown>) => Object.values(row)),
            theme: 'plain',
            startY: 20, // Start the table below the title
            styles: {
                fontSize: 10,
                cellPadding: 0.5,
                lineColor: 40,
                lineWidth: 0.1,
            },
            headStyles: {
                fontStyle: 'bold',
                textColor: 0,
                halign: 'center'
                // fillColor: [220, 220, 220], // Light gray background for the header
            },
            columnStyles: {
                0: { cellWidth: 40,halign: 'center' },
                1: { cellWidth: 50,halign: 'center' },
                2: { cellWidth: 50,halign: 'center' },
                3: { cellWidth: 50 },
                4: { cellWidth: 50 },
            },
        });

        addPageNumber(doc);
        const pdfBlob = doc.output('blob');
        setPdfBlob(pdfBlob);
    };

    useEffect(() => {
        if (data) {
            generatePDF();
        }
    }, [data]);

    return null; // No visual component, generates the PDF automatically
};

export default ExportDistrictLabelReport;
